export const GET_PAGES_SUCCESS = "GET_PAGES_SUCCESS"
export const CLEAR_ACTUAL_PAGE_ID = "CLEAR_ACTUAL_PAGE_ID"

